import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import SharingDialog from 'Workspace/components/SharingDialog';
import Card from 'components/Card';

import {
  commandGrantPermissionOnTeam,
  commandIamTeamAccountSummary,
  commandRevokePermissionOnTeam,
} from 'containers/ConnectionManager/actions';
import { collaboratorShape } from 'Workspace/types/collaborator';
import { selectTeamAccounts } from 'Workspace/Admin/store/selectors';
import { teamShape } from 'Workspace/types/team';

import {
  TeamCardContainer,
  TeamCardHeader,
  TeamCardTitle,
  TeamCardContent,
} from './styles';

class TeamCard extends React.Component {
  componentDidMount() {
    this.props.getTeamAccountSummary(this.props.data.teamId);
  }

  render() {
    const { name, teamId } = this.props.data;
    const { teamAccounts, revokePermission, theme } = this.props;

    return (
      <Card>
        <TeamCardContainer>
          <TeamCardHeader>
            <TeamCardTitle>{name}</TeamCardTitle>
          </TeamCardHeader>
          <TeamCardContent>
            <SharingDialog
              avatarBorderColor={theme['color.surface']}
              sharedWith={{ accounts: teamAccounts }}
              refId={teamId}
              hasStorageInPermissionGrant
              permissionGrantCommand={commandGrantPermissionOnTeam}
              handleDelete={(account) => revokePermission([account.id], teamId)}
            />
          </TeamCardContent>
        </TeamCardContainer>
      </Card>
    );
  }
}

TeamCard.propTypes = {
  data: teamShape,
  getTeamAccountSummary: PropTypes.func,
  revokePermission: PropTypes.func,
  teamAccounts: PropTypes.arrayOf(collaboratorShape),
  theme: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  getTeamAccountSummary: (teamId) => dispatch(commandIamTeamAccountSummary(teamId)),
  revokePermission: (accountId, teamId) => dispatch(commandRevokePermissionOnTeam(accountId, teamId)),
});

const mapStateToProps = (state, ownProps) => ({
  teamAccounts: selectTeamAccounts(state, ownProps.data.teamId),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(TeamCard));
